(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[558],{

/***/ 2595:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/chat",
      function () {
        return __webpack_require__(4710);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ MarkdocComponent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _markdoc_markdoc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4211);
/* harmony import */ var _opt_buildhome_repo_node_modules_markdoc_next_js_src_runtime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);
/* harmony import */ var _opt_buildhome_repo_markdoc_tags_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5185);
/* harmony import */ var _opt_buildhome_repo_markdoc_nodes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5160);

// renderers is imported separately so Markdoc isn't sent to the client


/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */ const config = {};


const functions = {};
const schema = {
    tags: _opt_buildhome_repo_markdoc_tags_js__WEBPACK_IMPORTED_MODULE_2__ ? _opt_buildhome_repo_markdoc_tags_js__WEBPACK_IMPORTED_MODULE_2__["default"] || _opt_buildhome_repo_markdoc_tags_js__WEBPACK_IMPORTED_MODULE_2__ : {},
    nodes: _opt_buildhome_repo_markdoc_nodes_js__WEBPACK_IMPORTED_MODULE_3__ ? _opt_buildhome_repo_markdoc_nodes_js__WEBPACK_IMPORTED_MODULE_3__["default"] || _opt_buildhome_repo_markdoc_nodes_js__WEBPACK_IMPORTED_MODULE_3__ : {},
    functions: functions ? functions.default || functions : {},
    ...config ? config.default || config : {}
};
const { components  } = (0,_opt_buildhome_repo_node_modules_markdoc_next_js_src_runtime_js__WEBPACK_IMPORTED_MODULE_1__/* .getSchema */ .J)(schema);
var __N_SSG = true;
function MarkdocComponent(props) {
    // Only execute HMR code in development
    return _markdoc_markdoc__WEBPACK_IMPORTED_MODULE_4__/* .renderers.react */ .RZ.react(props.markdoc.content, react__WEBPACK_IMPORTED_MODULE_0__, {
        components: {
            ...components,
            // Allows users to override default components at runtime, via their _app
            ...props.components
        }
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [649,448,774,888,179], function() { return __webpack_exec__(2595); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);